import { render } from "./BusinessComp.vue?vue&type=template&id=22af1688&scoped=true"
import script from "./BusinessComp.vue?vue&type=script&lang=js"
export * from "./BusinessComp.vue?vue&type=script&lang=js"

import "./BusinessComp.vue?vue&type=style&index=0&id=22af1688&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22af1688"]])

export default __exports__